import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import styled from 'styled-components'
import NoSSR from 'react-no-ssr'

const SliderWrapper = styled.div`{
  margin-bottom: 50px;
  
  .slick-list {
    padding-top: 5px;
    padding-bottom: 7px;
  }
  
  & .slick-dots {
    bottom: -40px;
    & li{
      margin: 0 10px;
    }
  }
  .slick-dots li button:before {
    font-size: 12px;
  }
  
  .ui.card.card.card {
    margin: auto;
  }
}`

const Arrow = styled.a`
  transition: 0.3s;
  position: absolute;
  z-index: 100;
  height: 50px;
  width: 40px;
  display: flex;
  justify-content: center;
  top: 50%;
  background-color: rgba(255,255,255,0.5);
  transform: translateY(-50%);
  color: ${(props) => (props.theme.colors.black)};
  font-size: ${(props) => (props.theme.fonts.sizes.h1.massive)};
  &:hover {
    background-color: rgba(0,0,0,0.1);
    color: black;
    cursor: pointer;
    i {
      color: rgba(0,0,0,1);
    }
  }
  ${({ direction }) => {
    const reverseDirection = direction === 'left' ? 'right' : 'left'
    return {
      [`border-top-${reverseDirection}-radius`]: '3px',
      [`border-bottom-${reverseDirection}-radius`]: '3px',
      [direction]: 0,
    }
  }}
  i {
    outline: none;
    align-self: center;
    width: auto;
    height: auto;
    margin: 0;
    margin-bottom: 3px;
  }
`

const NextArrow = ({ onClick }) => {
  return (
    <Arrow
      direction="right"
      onClick={(e) => {
        e.stopPropagation()
        return onClick(e)
      }}
    >
      <i
        role="button"
        tabIndex="0"
        className="fa fa-angle-right"
      />
    </Arrow>
  )
}

const PrevArrow = ({ onClick }) => {
  return (
    <Arrow
      direction="left"
      onClick={(e) => {
        e.stopPropagation()
        return onClick(e)
      }}
    >
      <i
        role="button"
        tabIndex="0"
        className="fa fa-angle-left"
      />
    </Arrow>
  )
}

const SlickSlider = ({
  style,
  items,
  settings = {},
}) => {
  const {
    nextArrow = <NextArrow />,
    prevArrow = <PrevArrow />,
    arrows = false,
    dots = false,
    slidesToShow = 1,
    ...otherSettings
  } = settings
  return (items && items.length) ? (
    <SliderWrapper style={style}>
      <NoSSR>
        <Slider
          nextArrow={nextArrow}
          prevArrow={prevArrow}
          arrows={arrows}
          dots={dots}
          {...otherSettings}
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToShow}
        >
          {items.map((item, i) => (
            <div key={i} style={{ textAlign: 'center' }}>
              {item}
            </div>
          ))}
        </Slider>
      </NoSSR>
    </SliderWrapper>
  ) : null
}

SlickSlider.propTypes = {}
SlickSlider.defaultProps = {}

export default SlickSlider



// WEBPACK FOOTER //
// ./src/cms/components/slider/SlickSlider.js